// extracted by mini-css-extract-plugin
export var content = "_3w-3";
export var list = "_3w-4";
export var settingsContent = "_3w-7";
export var settingsPanel = "_3w-8";
export var state = "_3w-6";
export var triggerBadge = "_3w-2";
export var triggerButton = "_3w-1";
export var triggerShell = "_3w-0";
export var unreadDot = "_3w-5";